export default __webpack_public_path__ + "static/media/spr-lesson-builder-dark-large.c92ecacb.jpg";